import { useKiosk } from "../../components/providers/KioskProvider";
import { useParker } from "../../providers/parker";
import { type SupportUrlParams, buildSupportUrl } from "../../utils/support-url";

export const useSupportUrl = (params: SupportUrlParams = {}) => {
	const { parker } = useParker();
	const { isKiosk } = useKiosk();
	const parkerId = !isKiosk && parker && "id" in parker ? parker.id : undefined;
	return { supportUrl: buildSupportUrl({ ...params, parkerId }) };
};
